// Top header con título de sección y dropdown de usuario.

import { type ReactNode } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Icon } from '@/components/atoms/Icon';
import { useAuth } from '@/context/AuthContext';
import styles from './Header.module.scss';

interface HeaderProps {
  title: string;
  actions?: ReactNode;
}

export function Header({ title, actions }: HeaderProps) {
  const { state, logout } = useAuth();
  const user = state.status === 'authenticated' ? state.user : null;
  const initials = user ? user.displayName.split(' ').map((p) => p[0]).slice(0, 2).join('').toUpperCase() : '?';

  return (
    <header className={styles.header}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.right}>
        {actions}
        {user && (
          <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
              <button className={styles.userButton} aria-label="Menú de usuario">
                <span className={styles.avatar}>{initials}</span>
                <span className={styles.userName}>{user.displayName}</span>
                <Icon name="chevron-down" size={16} />
              </button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Portal>
              <DropdownMenu.Content className={styles.menu} sideOffset={6} align="end">
                <DropdownMenu.Label className={styles.menuLabel}>
                  <div>{user.displayName}</div>
                  <div className={styles.userRoles}>{user.roles.join(', ') || 'sin rol'}</div>
                </DropdownMenu.Label>
                <DropdownMenu.Separator className={styles.separator} />
                <DropdownMenu.Item className={styles.menuItem} onSelect={() => void logout()}>
                  <Icon name="log-out" size={16} /> Cerrar sesión
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu.Portal>
          </DropdownMenu.Root>
        )}
      </div>
    </header>
  );
}
